var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"600px"}},[(this.$store.state.langchange)?_c('div',[_vm._v(_vm._s(_vm.updatedata()))]):_vm._e(),_c('product',{attrs:{"id":this.$route.params.id,"name":this.$route.params.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }